module.exports = __webpack_public_path__ + "img/workshop2-pc.9f03c250.png";